import { axios, API } from './config';

export const quoteRequestsAPI = {
  getAll: async (status = null) => {
    const params = status ? { status } : {};
    const response = await axios.get(`${API}/quote-requests`, { params });
    return response.data;
  },
  
  getById: async (id) => {
    const response = await axios.get(`${API}/quote-requests/${id}`);
    return response.data;
  },
  
  create: async (data) => {
    const response = await axios.post(`${API}/quote-requests`, data);
    return response.data;
  },
  
  updateStatus: async (id, status) => {
    const response = await axios.patch(`${API}/quote-requests/${id}/status`, { status });
    return response.data;
  },
  
  delete: async (id) => {
    const response = await axios.delete(`${API}/quote-requests/${id}`);
    return response.data;
  },
  
  convertToContract: async (id) => {
    const response = await axios.post(`${API}/quote-requests/${id}/convert-to-contract`);
    return response.data;
  }
};
